import { useNavigate } from 'react-router';

import {
  APP_PAGES,
  INBOX_PREVIEW_FROM_VALUES,
  INBOX_PREVIEW_QUERY_PARAMS,
} from '../../routes/constants';
import { useDoBoxDropdownStore } from '../../store';
import { getCurrentTabParam } from '../../utils/getCurrentTabParam';

export function useNavigateToInboxPreview() {
  const navigate = useNavigate();
  const isDobox = window.location.pathname.includes(APP_PAGES.DOBOX);
  const isLabels = window.location.pathname.includes(APP_PAGES.INBOX_LABELS);
  const isSnoozed = window.location.pathname.includes(APP_PAGES.INBOX_SNOOZED);

  const navigateToInboxPreview = (
    id: string,
    options?: { doboxId?: string; draftId?: string },
  ) => {
    const currentTab = getCurrentTabParam();
    const basePath = isDobox ? APP_PAGES.DOBOX : APP_PAGES.INBOX;

    const params = new URLSearchParams();
    if (currentTab) {
      params.set('tab', currentTab);
    }
    if (isLabels) {
      params.set(
        INBOX_PREVIEW_QUERY_PARAMS.FROM,
        INBOX_PREVIEW_FROM_VALUES.LABELS,
      );
    }
    if (isSnoozed) {
      params.set(
        INBOX_PREVIEW_QUERY_PARAMS.FROM,
        INBOX_PREVIEW_FROM_VALUES.SNOOZED,
      );
    }
    if (options?.doboxId) {
      params.set(INBOX_PREVIEW_QUERY_PARAMS.DOBOX_ID, options.doboxId);
    }
    if (options?.draftId) {
      params.set(INBOX_PREVIEW_QUERY_PARAMS.DRAFT, options.draftId);
    }

    const previewPath = `${basePath}/preview/${encodeURIComponent(id)}`;
    const targetUrl = params.toString()
      ? `${previewPath}?${params.toString()}`
      : previewPath;

    const { setFromDoBoxPreview } = useDoBoxDropdownStore.getState();
    if (isDobox && basePath === APP_PAGES.DOBOX) {
      setFromDoBoxPreview(true);
    } else {
      setFromDoBoxPreview(false);
    }

    navigate(targetUrl);
  };

  return { navigateToInboxPreview };
}
